var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"app-multiselect__select-all-button",on:{"click":function($event){return _vm.selectAll()}}},[_vm._v(" "+_vm._s(_vm.footerText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }